import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3df9a26a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper--router-view" }
const _hoisted_2 = { class: "login-wrapper--router-view-content" }
const _hoisted_3 = { class: "login-wrapper--incredibuild-logo row items-center justify-center" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_grid = _resolveComponent("q-spinner-grid")!
  const _component_login_bg = _resolveComponent("login-bg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "login-wrapper",
    style: _normalizeStyle({ justifyContent: _ctx.loading ? 'center' : 'initial' })
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_q_spinner_grid, {
        class: "text-brand_almost_black",
        style: {"align-items":"center","margin":"14px auto 0 auto"},
        size: "4em"
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode(_component_login_bg, {
      red: _ctx.isBgColorRed,
      class: "login-wrapper--login-bg"
    }, null, 8, ["red"]), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.incredibuildLogo,
            alt: "incredibuild-logo"
          }, null, 8, _hoisted_4)
        ]),
        _createVNode(_component_router_view, { onLoading: _ctx.setLoading }, null, 8, ["onLoading"])
      ])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 4))
}